import { FC } from 'react';

import { Field, Fieldset, TextInput, Select } from '@/components';

import { CreateProjectFormData } from '../types';

interface BasicInformationFieldsProps {
  formData: CreateProjectFormData;
  errors: Partial<Record<keyof CreateProjectFormData, string>>;
  onFieldChange: (field: keyof CreateProjectFormData, value: unknown) => void;
  countryOptions: Array<{ label: string; value: string }>;
  organizationOptions: Array<{ label: string; value: string }>;
  isAecomUser?: boolean;
}

export const BasicInformationFields: FC<BasicInformationFieldsProps> = ({
  formData,
  errors,
  onFieldChange,
  countryOptions,
  organizationOptions,
  isAecomUser = false,
}) => {
  return (
    <Fieldset legend="Basic Information">
      <Field label="Project Name" htmlFor="project-name-input" error={errors.name} required>
        <TextInput
          placeholder={isAecomUser ? 'Auto-filled from Oracle project' : 'Enter project name'}
          fullWidth
          value={formData.name}
          onChange={(e) => !isAecomUser && onFieldChange('name', e.target.value)}
          readOnly={isAecomUser}
          className={isAecomUser ? 'cursor-default bg-muted text-muted-foreground' : ''}
        />
      </Field>
      <Field label="Country" htmlFor="country-select" error={errors.country} required>
        <Select
          options={countryOptions}
          value={
            formData.country
              ? countryOptions.find((option) => option.value === formData.country)
              : undefined
          }
          onValueChange={(value) => {
            onFieldChange('country', value ? value.value : null);
          }}
          placeholder="Select Country"
          className="w-full"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          showSearch={true}
        />
      </Field>
      <Field
        label="Organization"
        htmlFor="organization-select"
        error={errors.organizationId}
        required
      >
        <Select
          options={organizationOptions}
          value={
            formData.organizationId
              ? organizationOptions.find((option) => option.value === formData.organizationId)
              : undefined
          }
          onValueChange={(value) => {
            onFieldChange('organizationId', value ? value.value : '');
          }}
          placeholder="Select Organization"
          className="w-full"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          showSearch={true}
        />
      </Field>
      {!isAecomUser && (
        <Field label="Address" htmlFor="address-input" error={errors.address}>
          <TextInput
            placeholder="Enter project address"
            fullWidth
            value={formData.address}
            onChange={(e) => onFieldChange('address', e.target.value)}
          />
        </Field>
      )}
    </Fieldset>
  );
};
